import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Modal } from 'Components/Modal'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'

import { pushApiError, removeOldestApiError } from 'Reducers/Errors/actions'
import SubmitButton from 'Components/Form/SubmitButton'
import { authorization } from 'Module/Auth/Auth'
class APIErrorHandler extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
    }

    this.showErrorModal = this.showErrorModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
  }

  componentDidMount() {
    const { apiErrors } = this.props
    if (apiErrors.length > 0) {
      this.showErrorModal()
    }
  }

  componentDidUpdate(prevProps) {
    const triggerErrorSideEffects = error => {
      if (
        error == 'Failed to authenticate token' ||
        error == 'Token expired. Please login again.'
      ) {
        authorization.logout()
        setTimeout(() => window.location.reload(true), 2000)
      }
    }
    const { apiErrors } = this.props
    if (
      apiErrors.length > 0 &&
      prevProps.apiErrors.length !== apiErrors.length
    ) {
      this.showErrorModal()
      triggerErrorSideEffects(apiErrors[0].message)
    }
  }

  showErrorModal() {
    this.setState({
      showModal: true,
    })
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
    })
  }

  render() {
    const { showModal } = this.state
    const { removeOldestApiError } = this.props

    return (
      <div>
        <Modal show={showModal} onExited={removeOldestApiError}>
          <ModalHeader>
            <ModalTitle>API Error</ModalTitle>
          </ModalHeader>
          <ModalBody>{this.renderErrorMessages()}</ModalBody>
          <ModalFooter>
            <SubmitButton value="Close" onClick={this.handleCloseModal} />
          </ModalFooter>
        </Modal>
      </div>
    )
  }

  renderErrorMessages() {
    const { apiErrors } = this.props
    const errorMessage = apiErrors[0]
      ? apiErrors[0].message || apiErrors[0]
      : 'Unknown error'
    let detailedErrorsJSX = []
    if (apiErrors[0] && apiErrors[0].errors) {
      apiErrors[0].errors.forEach((error, index) =>
        detailedErrorsJSX.push(
          <div key={`detailed-error-${index}`}>{error.message}</div>,
        ),
      )
    }
    return (
      <div>
        {errorMessage}
        {detailedErrorsJSX}
      </div>
    )
  }
}

APIErrorHandler.propTypes = {
  apiErrors: PropTypes.array.isRequired,
  pushApiError: PropTypes.func.isRequired,
  removeOldestApiError: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  apiErrors: state.errors.apiErrors,
})

export default connect(
  mapStateToProps,
  {
    removeOldestApiError,
    pushApiError,
  },
)(APIErrorHandler)



// WEBPACK FOOTER //
// ./src/Containers/APIErrorHandler/index.js